import { FC, PropsWithChildren, useState } from 'react';
import { EmailThreadContent } from './types';
import EmailThreadModal from './EmailThreadModal';
import { useAuth } from 'context/auth';
import useGetTaskEmail from 'hooks/services/event/useGetTaskEmail';
import { EmailThreadContext } from './context';

export { useEmailThread } from './context';

// Provider of the sideTab
const EmailThreadProvider: FC<PropsWithChildren> = ({ children }) => {
  const [emailThreadContent, setEmailThreadContent] =
    useState<EmailThreadContent | null>(null);
  const { user } = useAuth();

  //We retrieve the emailTask so that if we don't have the activity we can show something
  const { data: emailTask } = useGetTaskEmail({
    prospectId: emailThreadContent?.prospect?.objectId ?? undefined,
    emailId: emailThreadContent?.emailId ?? undefined,
    withLog: true,
  });
  //There are some cases in which this is opened from another provided that is not accessible from here, so to close it on redirect we need to set the function when opening this
  const [closeToRedirectInboxFunction, setCloseToRedirectInboxFunction] =
    useState<(() => void) | undefined>(() => {});
  return (
    <EmailThreadContext.Provider
      value={{
        setEmailThreadContent,
        emailThreadContent: emailThreadContent,
        setCloseToRedirectInboxFunction,
      }}
    >
      {Boolean(user) && emailThreadContent ? (
        <div
          className="email-thread-container"
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <EmailThreadModal
            {...emailThreadContent}
            activity={
              emailThreadContent.activity ?? emailTask?.data?.data ?? undefined
            }
            close={() => {
              setEmailThreadContent(null);
              if (closeToRedirectInboxFunction) closeToRedirectInboxFunction();
            }}
          />
        </div>
      ) : null}
      {children}
    </EmailThreadContext.Provider>
  );
};

export default EmailThreadProvider;
